export interface NavigationItem {
  name: string;
  href: string;
  // Desktop-only: controls whether this top-level item appears on the left or right side of the headeer
  desktopPosition?: "left" | "right";
  children?: NavigationItem[];
}

export const navigation: NavigationItem[] = [
  {
    name: "L'école de tennis",
    href: "/ecole-de-tennis",
    desktopPosition: "left",
    children: [
      { name: "Groupes enfants", href: "/ecole-de-tennis/groupes-enfants" },
      { name: "Groupes adultes", href: "/ecole-de-tennis/groupes-adultes" },
      { name: "Enseignants", href: "/ecole-de-tennis/enseignants" },
      { name: "Calendrier", href: "/#calendrier" },
    ],
  },
  { name: "Tarifs", href: "/tarifs", desktopPosition: "left" },
  {
    name: "Fête le mur",
    href: "/fete-le-mur",
    desktopPosition: "left",
  },
  {
    name: "Partenaires",
    href: "/partenaires",
    desktopPosition: "right",
  },
  { name: "Contact", href: "/#contact", desktopPosition: "right" },
];
